export const API_URL_CONFIG = 'https://stageapi.dbraei.edu.in/api/v1/';
export const IMG_URL_CONFIG = '';
export const IMG_CONTAINER = 'dbraei-stage';
export const isProduction =false;
export const GEOSERVICE_API = 'https://devservices.visaka.io/api/';
export const ASSET_URL_CONFIG = 'https://dbraeiassetmanagement.blob.core.windows.net/';
export const ASSET_CONTAINER_NAME = 'dbraei-stage';
export const ASSET_SAS_TOKEN = 'sp=rw&st=2025-06-20T10:43:06Z&se=2026-06-20T18:43:06Z&spr=https&sv=2024-11-04&sr=c&sig=hGYuAcvQMTR5FcL%2FsUqtg7tlRNwBp%2BKDckIWA4eFAXk%3D';
